import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { reviewData } from "utils/data";

export function DemoCarousel() {
  return (
    <Carousel
      className="customer-reviews__carousel"
      autoPlay
      interval={4500}
      infiniteLoop
      showArrows
      showIndicators
      showStatus={false}
      showThumbs={false}
      swipeable
      preventMovementUntilSwipeScrollTolerance
      swipeScrollTolerance={50}
    >
      {reviewData.map((item) => (
        <article className="customer-review-card" key={item.name}>
          <div className="customer-review-card__client">
            <div className="customer-review-card__portrait-ring">
              <img
                src={item.image}
                alt={`${item.name} wearing makeup by Arpita's Makeover`}
                loading="lazy"
                decoding="async"
              />
            </div>
            <h3>{item.name}</h3>
            <p className="customer-review-card__profession">{item.profession}</p>
            <div className="customer-review-card__rating" aria-label="5 out of 5 stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <i className="fas fa-star" aria-hidden="true" key={star} />
              ))}
            </div>
          </div>

          <div className="customer-review-card__quote">
            <span className="customer-review-card__quote-mark" aria-hidden="true">
              <i className="fas fa-quote-left" />
            </span>
            <blockquote>{item.personReview}</blockquote>
            <div className="customer-review-card__quote-footer">
              <span />
              <p>Shared by {item.name}</p>
            </div>
          </div>
        </article>
      ))}
    </Carousel>
  );
}
